import { useMutation } from '@tanstack/react-query'
import { putHppPaymentMethods } from 'services/HppSettingsService'
import type { HppPaymentMethodsPayload } from 'types/hppSettings'
import { logSentryError } from 'utils/sentry'

export const useUpdateHppPaymentMethodsMutation = () =>
  useMutation({
    mutationFn: (data: HppPaymentMethodsPayload) => putHppPaymentMethods(data),
    onError(error, data) {
      logSentryError('Error from useUpdateHppPaymentMethodsMutation', error, data)
    },
  })
